var map = {
	"./alberta-amazing-attraction-banff-417074.jpg": 26,
	"./autumn-leaves-beautiful-color-206648.jpg": 27,
	"./black-and-gray-dome-tent-1795507.jpg": 28,
	"./brown-house-near-pine-trees-covered-with-snow-754268.jpg": 29,
	"./drone-view-of-magnificent-rocky-terrain-in-mongolia-4326283.jpg": 30,
	"./green-leafed-trees-2271098.jpg": 31,
	"./mountains-between-the-body-of-water-1482931.jpg": 32,
	"./person-on-a-bridge-near-a-lake-747964.jpg": 33,
	"./photo-of-house-covered-with-snow-1493202.jpg": 34,
	"./photo-taken-on-body-of-water-1127032.jpg": 35,
	"./piled-of-stones-near-lake-2825368.jpg": 36,
	"./woodland-stream-covered-with-snow-816042.jpg": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;